// Footer news publications
export const FOOTER_NEWS_PUBLICATIONS = [
  {
    title: "The Straits Times",
    url: "https://www.straitstimes.com",
    target: "_blank",
  },
  {
    title: "The Business Times",
    url: "https://www.businesstimes.com.sg",
    target: "_blank",
  },
  {
    title: "Lianhe Zaobao",
    url: "https://www.zaobao.com.sg",
    target: "_blank",
  },
  {
    title: "Berita Harian",
    url: "https://www.beritaharian.sg",
    target: "_blank",
  },
  {
    title: "Tamil Murasu",
    url: "https://www.tamilmurasu.com.sg",
    target: "_blank",
  },
  {
    title: "Stomp",
    url: "https://www.stomp.sg",
    target: "_blank",
  },
];

/**
 * UTM parameters for footer news publication links
 * utm_source=tm
 * utm_medium=sph-publication
 * utm_campaign=backlinks-footer
 */
export function getFooterNewsPublicationsQuery(): string {
  return new URLSearchParams({
    utm_source: "tm",
    utm_medium: "sph-publication",
    utm_campaign: "backlinks-footer",
  }).toString();
}

/**
 * Optional: helper that builds the full URL including the UTM query,
 * preserving existing query separator if any.
 */
export function buildFooterPublicationUrl(publicationUrl: string): string {
  const query = getFooterNewsPublicationsQuery();
  const sep = publicationUrl.includes("?") ? "&" : "?";
  return `${publicationUrl}${sep}${query}`;
}
